import creditCardType from "credit-card-type";
import * as _ from "lodash-es";
import moment from "moment";
import React, { ChangeEvent, Component } from "react";
import { NumericFormat } from "react-number-format";
import ICreateAChargeDTO from "../../../models/DTO/ICreateAChargeDTO";
import ICreateCardFromTokenDTO from "../../../models/DTO/ICreateCardFromTokenDTO";
import IDeleteACardDTO from "../../../models/DTO/IDeleteACardDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetCardsDTO from "../../../models/DTO/IGetCardsDTO";
import IOnCreateAChargeDTO from "../../../models/DTO/IOnCreateAChargeDTO";
import IOnCreateCardFromTokenDTO from "../../../models/DTO/IOnCreateCardFromTokenDTO";
import IOnDeleteACardDTO from "../../../models/DTO/IOnDeleteACardDTO";
import IOnGetCardsDTO from "../../../models/DTO/IOnGetCardsDTO";
import IOnUpdateOrderCardToUseDTO from "../../../models/DTO/IOnUpdateOrderCardToUseDTO";
import IUpdateOrderCardToUseDTO from "../../../models/DTO/IUpdateOrderCardToUseDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import IOrder from "../../../models/IOrder";
import IOrder_Progress_State from "../../../models/IOrder_Progress_State";
import IQBPaymentCard from "../../../models/IQBPaymentCard";
import IQBPaymentsDetails from "../../../models/IQBPaymentsDetails";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import QBPaymentsCardTypeEnum from "../../../models/QBPaymentsCardTypeEnum";
import QuickbooksPaymentsService from "../../../services/QuickbooksPaymentsService";
import ActivityIndicator from "../ActivityIndicator/ActivityIndicator";
import OwButton from "../OwButton/OwButton";
import OwCheckbox from "../OwCheckbox/OwCheckbox";
import OwInputWrapper from "../OwInputWrapper/OwInputWrapper";
import OwLabel from "../OwLabel/OwLabel";
import OwSelectOption from "../OwSelectOption/OwSelectOption";
import OwTitle from "../OwTitle/OwTitle";
import IGetCardDTO from "../../../models/DTO/IGetCardDTO";
import IOnGetCardDTO from "../../../models/DTO/IOnGetCardDTO";
import UIService from "../../../services/UIService";
import { OwFnInput } from "../OwFnInput/OwFnInput";
import { Socket } from "socket.io-client";
import "./OrderPayment.scss";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    orderModel: IOrder;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    cancelFn: (refresh?: boolean) => void;
    confirmFn: (refresh?: boolean) => void;
    nextStep?: IOrder_Progress_State;
};

type State = {
    card?: string;
    exp_month?: string;
    exp_year?: string;
    cvc?: string;
    name?: string;
    billing_postal_code?: number;
    ccSelected: {
        visa: boolean;
        mc: boolean;
        amex: boolean;
        disc: boolean;
        diners: boolean;
        jcb: boolean;
    };
    isChargeDisabled: boolean;
    save_card: boolean;
    existing_card?: IQBPaymentCard;
    existingCards: IQBPaymentCard[];
    getExistingCardsActive: boolean;
    useExistingCard: boolean;
    cardSelected: boolean;
    isProcessing: boolean;
    doneProcessing: boolean;
    updatedCardToUse: boolean;
};

export default class OrderPayment extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            exp_year: "20",
            ccSelected: {
                visa: false,
                mc: false,
                amex: false,
                disc: false,
                diners: false,
                jcb: false,
            },
            isChargeDisabled: !this.props.orderModel.qbo_CardToUseDetail,
            save_card: true,
            existingCards: [],
            getExistingCardsActive: true,
            useExistingCard: true,
            cardSelected: false,
            isProcessing: false,
            doneProcessing: false,
            updatedCardToUse: false,
            existing_card: this.props.orderModel.qbo_CardToUseDetail ? this.props.orderModel.qbo_CardToUseDetail : undefined,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.PaymentsOnGetCards, this.onGetCards);
        this.props.socket.on(EndpointsEnum.PaymentsOnCreateCardFromToken, this.onCreateCardFromToken);
        this.props.socket.on(EndpointsEnum.PaymentsOnDeleteACard, this.onDeleteExistingCard);
        this.props.socket.on(EndpointsEnum.PaymentsOnCreateACharge, this.onCreateACharge);
        this.props.socket.on(EndpointsEnum.OrderOnUpdateOrderCardToUse, this.onUpdateOrderCardToUse);
        this.props.socket.on(EndpointsEnum.Notify, this.notify);
        this.props.socket.on(EndpointsEnum.PaymentsOnGetCard, this.onGetCard);

        this.getCards();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.PaymentsOnGetCards, this.onGetCards);
        this.props.socket.removeListener(EndpointsEnum.PaymentsOnCreateCardFromToken, this.onCreateCardFromToken);
        this.props.socket.removeListener(EndpointsEnum.PaymentsOnDeleteACard, this.onDeleteExistingCard);
        this.props.socket.removeListener(EndpointsEnum.PaymentsOnCreateACharge, this.onCreateACharge);
        this.props.socket.removeListener(EndpointsEnum.OrderOnUpdateOrderCardToUse, this.onUpdateOrderCardToUse);
        this.props.socket.removeListener(EndpointsEnum.Notify, this.notify);
        this.props.socket.removeListener(EndpointsEnum.PaymentsOnGetCard, this.onGetCard);
    }

    notify = (data: IErrorDTO) => {
        if (data.title === "ERROR_CREATING_A_CHARGE") {
            this.setState({
                isProcessing: false,
            });
        }
    };

    getCards = () => {
        const payload: IGetCardsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.orderModel.Vendor!.guid,
        };

        this.props.socket.emit(EndpointsEnum.PaymentsGetCards, payload);

        this.setState({
            getExistingCardsActive: true,
        });
    };

    onGetCards = (data: IOnGetCardsDTO) => {
        this.setState({
            existingCards: data.cards,
            useExistingCard: !!data.cards.length,
            getExistingCardsActive: false,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        if (name === "card") {
            const ccSelected = this.state.ccSelected;

            ccSelected.visa = false;
            ccSelected.mc = false;
            ccSelected.amex = false;
            ccSelected.disc = false;
            ccSelected.diners = false;
            ccSelected.jcb = false;

            if (value.length > 4) {
                const cardTypeDetail = creditCardType(value);

                if (cardTypeDetail.length) {
                    const firstCardType = cardTypeDetail[0];

                    switch (firstCardType.type) {
                        case "visa":
                            ccSelected.visa = true;
                            break;

                        case "mastercard":
                            ccSelected.mc = true;
                            break;

                        case "american-express":
                            ccSelected.amex = true;
                            break;

                        case "discover":
                            ccSelected.disc = true;
                            break;

                        case "diners-club":
                            ccSelected.diners = true;
                            break;

                        case "jcb":
                            ccSelected.jcb = true;
                            break;
                    }

                    state.ccSelected = ccSelected;
                }
            }
        }

        this.setState(state, () => {
            if (
                this.state.name?.length &&
                this.state.card?.length &&
                this.state.exp_month?.length &&
                this.state.exp_year?.length &&
                this.state.cvc?.length
            ) {
                this.setState({
                    isChargeDisabled: false,
                });
            }
        });
    };

    createCardFromToken = (token: string) => {
        const payload: ICreateCardFromTokenDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.orderModel.Vendor!.guid,
            cardToken: token,
        };

        this.props.socket.emit(EndpointsEnum.PaymentsCreateCardFromToken, payload);
    };

    onCreateCardFromToken = (data: IOnCreateCardFromTokenDTO) => {
        if (this.props.nextStep?.collectPayment) {
            this.createCharge(data.card_id, true);
        } else {
            console.log("getCard");
            this.getCard(data.card_id);
        }
    };

    getCard = (cardId: string) => {
        const payload: IGetCardDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.orderModel.Vendor!.guid,
            cardId,
        };

        this.props.socket.emit(EndpointsEnum.PaymentsGetCard, payload);
    };

    onGetCard = (data: IOnGetCardDTO) => {
        console.log("onGetCard: ", data);
        if (data.card) {
            this.updateOrderCardToUse(data.card);
        }
    };

    updateOrderCardToUse = (existingCard: IQBPaymentCard) => {
        const payload: IUpdateOrderCardToUseDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.orderModel.Vendor!.guid,
            orderGuid: this.props.orderModel.guid,
            qbo_CardToUseDetail: existingCard,
        };

        this.props.socket.emit(EndpointsEnum.OrderUpdateOrderCardToUse, payload);

        this.setState({
            isProcessing: true,
        });
    };

    onUpdateOrderCardToUse = (data: IOnUpdateOrderCardToUseDTO) => {
        const notification: INotification = {
            message: "successfully_updated_order_card_to_use",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            doneProcessing: true,
            updatedCardToUse: true,
        });
    };

    createCharge = (tokenOrId: string, storedCard: boolean) => {
        const payload: ICreateAChargeDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.orderModel.Vendor!.guid,
            orderGuids: [this.props.orderModel.guid],
            tokenOrId,
            storedCard,
        };

        this.props.socket.emit(EndpointsEnum.PaymentsCreateACharge, payload);

        this.setState({
            isProcessing: true,
        });
    };

    onCreateACharge = (data: IOnCreateAChargeDTO) => {
        // this.props.confirmFn();
        this.setState({
            doneProcessing: true,
        });
    };

    continue = async () => {
        if (this.state.existing_card && this.state.useExistingCard) {
            if (this.props.nextStep?.onlyCollectCcToUse) {
                this.updateOrderCardToUse(this.state.existing_card);
            } else {
                this.createCharge(this.state.existing_card.id, true);
            }
        } else {
            let cardType: QBPaymentsCardTypeEnum = QBPaymentsCardTypeEnum.VISA;

            if (this.state.ccSelected.mc) {
                cardType = QBPaymentsCardTypeEnum.MC;
            } else if (this.state.ccSelected.amex) {
                cardType = QBPaymentsCardTypeEnum.AMEX;
            } else if (this.state.ccSelected.disc) {
                cardType = QBPaymentsCardTypeEnum.DISC;
            } else if (this.state.ccSelected.jcb) {
                cardType = QBPaymentsCardTypeEnum.JCB;
            } else if (this.state.ccSelected.diners) {
                cardType = QBPaymentsCardTypeEnum.DINERS;
            } else {
                cardType = QBPaymentsCardTypeEnum.VISA;
            }

            if (cardType === QBPaymentsCardTypeEnum.AMEX) {
                if (this.state.cvc!.length < 4) {
                    const notification: INotification = {
                        message: "american_express_requires_cvc_4_digits",
                        level: NotificationLevelEnum.success,
                        position: NotificationPositionEnum.bc,
                    };

                    this.props.notifyFn(null, notification);

                    return;
                }
            }

            const details: IQBPaymentsDetails = {
                card: {
                    cardType,
                    number: this.state.card!.replace(/\s/g, "").replace(/_/g, ""),
                    name: this.state.name!,
                    expYear: this.state.exp_year!,
                    expMonth: this.state.exp_month!,
                    cvc: this.state.cvc!,
                    address: {
                        postalCode: this.state.billing_postal_code!,
                    },
                },
            };

            const token = await QuickbooksPaymentsService.createAToken("card", details);

            console.log("QB Payments Token", token);
            // 2) After they hit Submit - Send the token to the API, create the card (if new) with the token, and then charge the card.
            // 3) mark order as being authorized, and then move to the next step.
            // 4) if the current step will also capture the payment, then perform that at the api as well after the authorization.

            if (this.state.save_card) {
                this.createCardFromToken(token);
            } else {
                this.createCharge(token, false);
            }
        }
    };

    getSubTotal = () => {
        return (
            <tr>
                <th>
                    <OwLabel title={"sub_total"} postText={":"} />
                </th>
                <td className={"text-end"}>
                    <NumericFormat
                        value={this.props.orderModel.sub_total}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                    />
                </td>
            </tr>
        );
    };

    getDiscountTotal = () => {
        if (!this.props.orderModel.discount_total) {
            return null;
        }

        return (
            <React.Fragment>
                <tr>
                    <th>
                        <OwLabel title={"discount"} postText={":"} />
                    </th>
                    <td className={"text-end"}>
                        (
                        <NumericFormat
                            value={this.props.orderModel.discount_total}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            prefix={"$"}
                        />
                        )
                    </td>
                </tr>
                <tr>
                    <th>
                        <OwLabel title={"discounted_sub_total"} postText={":"} />
                    </th>
                    <td className={"text-end"}>
                        <NumericFormat
                            value={(this.props.orderModel.sub_total || 0) - (this.props.orderModel.discount_total || 0)}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            prefix={"$"}
                        />
                    </td>
                </tr>
            </React.Fragment>
        );
    };

    getTax = () => {
        return (
            <tr>
                <th>
                    <OwLabel title={"tax"} postText={":"} />
                </th>
                <td className={"text-end"}>
                    <NumericFormat
                        value={this.props.orderModel.tax}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                    />
                </td>
            </tr>
        );
    };

    getLabor = () => {
        return this.props.supplierModel.has_labor_fee ? (
            <tr>
                <th>
                    <OwLabel title={"labor"} postText={":"} />
                </th>
                <td className={"text-end"}>
                    <NumericFormat
                        value={this.props.orderModel.labor}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                    />
                </td>
            </tr>
        ) : null;
    };

    getShipping = () => {
        console.log("getShipping", this.props.orderModel.shipping);
        if (_.isNil(this.props.orderModel.shipping)) {
            return null;
        }

        return this.props.supplierModel.has_shipping_fee || this.props.orderModel.shipping ? (
            <tr>
                <th>
                    <OwLabel title={"shipping"} postText={":"} />
                </th>
                <td className={"text-end"}>
                    <NumericFormat
                        value={this.props.orderModel.shipping}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                    />
                </td>
            </tr>
        ) : null;
    };

    getCreditCardFee = () => {
        if (!this.props.supplierModel.has_credit_card_surcharge) {
            return null;
        }

        return this.props.supplierModel.has_credit_card_surcharge || this.props.orderModel.credit_card_surcharge_amount ? (
            <tr>
                <th>
                    <OwLabel title={"credit_card_fee"} postText={":"} />
                </th>
                <td className={"text-end"}>
                    <NumericFormat
                        value={this.props.orderModel.credit_card_surcharge_amount || 0}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                    />
                </td>
            </tr>
        ) : null;
    };

    getGrandTotal = () => {
        const grandTotal = this.props.orderModel.grand_total || 0;

        return (
            <tr>
                <th>
                    <OwLabel title={"grand_total"} postText={":"} />
                </th>
                <td className={"text-end"}>
                    <NumericFormat
                        value={grandTotal}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                    />
                </td>
            </tr>
        );
    };

    selectExistingCard = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        const card = this.state.existingCards.find((existingCard) => {
            if (value === existingCard.id) {
                return true;
            }
        });

        console.log("selectExistingCard: ", card, this.state.existingCards);

        if (card) {
            console.log("selectExistingCard: ", card);
            this.setState({
                existing_card: card,
                isChargeDisabled: false,
            });
        }
    };

    renderExistingCardOption = (data: IQBPaymentCard): string => {
        const lastFour = data.number.substr(data.number.length - 4, 4);
        return `${lastFour} - Exp: ${data.expMonth}/${data.expYear}`;
    };

    getCardEntry = () => {
        if (this.state.useExistingCard || this.state.cardSelected) {
            return null;
        }

        const monthOptions = [
            { value: "01", title: "01" },
            { value: "02", title: "02" },
            { value: "03", title: "03" },
            { value: "04", title: "04" },
            { value: "05", title: "05" },
            { value: "06", title: "06" },
            { value: "07", title: "07" },
            { value: "08", title: "08" },
            { value: "09", title: "09" },
            { value: "10", title: "10" },
            { value: "11", title: "11" },
            { value: "12", title: "12" },
        ];

        const yearOptions = [
            { value: moment().format("YYYY") },
            { value: moment().add(1, "year").format("YYYY") },
            { value: moment().add(2, "year").format("YYYY") },
            { value: moment().add(3, "year").format("YYYY") },
            { value: moment().add(4, "year").format("YYYY") },
            { value: moment().add(5, "year").format("YYYY") },
            { value: moment().add(6, "year").format("YYYY") },
            { value: moment().add(7, "year").format("YYYY") },
            { value: moment().add(8, "year").format("YYYY") },
            { value: moment().add(9, "year").format("YYYY") },
            { value: moment().add(10, "year").format("YYYY") },
            { value: moment().add(11, "year").format("YYYY") },
            { value: moment().add(12, "year").format("YYYY") },
            { value: moment().add(13, "year").format("YYYY") },
            { value: moment().add(14, "year").format("YYYY") },
            { value: moment().add(15, "year").format("YYYY") },
            { value: moment().add(16, "year").format("YYYY") },
            { value: moment().add(17, "year").format("YYYY") },
            { value: moment().add(18, "year").format("YYYY") },
            { value: moment().add(19, "year").format("YYYY") },
            { value: moment().add(20, "year").format("YYYY") },
        ];

        return (
            <div>
                <OwTitle title={"new_card"} tag={"h5"} />
                <div className="row">
                    <div className="col-12">
                        <OwLabel title={"card"} />
                        <OwInputWrapper
                            name={"card"}
                            fn={this.handleChange}
                            value={this.state.card}
                            maskedInput={true}
                            mask={"9999 9999 9999 9999"}
                            alwaysShowMask={false}
                            autoComplete="cc-number"
                        />
                    </div>

                    <div className={"col-12"}>
                        <i className={"fa-2x me-2 fab fa-cc-visa " + (this.state.ccSelected.visa ? "text-primary" : "")} />
                        <i className={"fa-2x me-2 fab fa-cc-mastercard " + (this.state.ccSelected.mc ? "text-primary" : "")} />
                        <i className={"fa-2x me-2 fab fa-cc-amex " + (this.state.ccSelected.amex ? "text-primary" : "")} />
                        <i className={"fa-2x me-2 fab fa-cc-discover " + (this.state.ccSelected.disc ? "text-primary" : "")} />
                        <i className={"fa-2x me-2 fab fa-cc-diners-club " + (this.state.ccSelected.diners ? "text-primary" : "")} />
                        <i className={"fa-2x fab fa-cc-jcb " + (this.state.ccSelected.jcb ? "text-primary" : "")} />
                    </div>

                    <div className="col-12 mt-3">
                        <OwLabel title={"exp_date"} />
                        <div className={"d-flex"}>
                            <div className={"w-5r me-2"}>
                                <OwSelectOption
                                    name={"exp_month"}
                                    options={monthOptions}
                                    titleProp={"title"}
                                    valueProp={"value"}
                                    selectedOption={this.state}
                                    selectedOptionProp={"exp_month"}
                                    fn={this.handleChange}
                                />
                            </div>
                            <div className={"w-5r"}>
                                <OwSelectOption
                                    name={"exp_year"}
                                    options={yearOptions}
                                    titleProp={"value"}
                                    valueProp={"value"}
                                    selectedOption={this.state}
                                    selectedOptionProp={"exp_year"}
                                    fn={this.handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={"col-12 mt-3"}>
                        <OwLabel title={"cvc"} />
                        <div className={"w-6r"}>
                            <OwFnInput enableDebounce={true} name={"cvc"} fn={this.handleChange} value={this.state.cvc} type={"number"} />
                        </div>
                    </div>

                    <div className={"col-12 mt-3"}>
                        <OwLabel title={"name_on_card"} />
                        <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.name} />
                    </div>

                    <div className={"col-12 mt-3"}>
                        <OwLabel title={"billing_postal_code"} />
                        <OwInputWrapper name={"billing_postal_code"} fn={this.handleChange} value={this.state.billing_postal_code} />
                    </div>
                </div>

                <div className={"row mt-3"}>
                    <div className={"col-12"}>
                        <OwCheckbox
                            name={"save_card"}
                            truthyVal={true}
                            falsyVal={false}
                            fn={this.handleChange}
                            label={"save_card"}
                            checked={this.state.save_card}
                            disabled={!!this.props.nextStep?.onlyCollectCcToUse}
                        />
                    </div>
                </div>
            </div>
        );
    };

    getCardSelectedView = () => {
        if (!this.state.cardSelected) {
            return null;
        }

        let card = "";
        let expDate = "";

        if (this.state.useExistingCard && this.state.existing_card) {
            card = this.state.existing_card.number;
            expDate = `${this.state.existing_card.expMonth}/${this.state.existing_card.expYear}`;
        } else {
            if (this.state.card) {
                const noSpacesCard = this.state.card!.replace(/\s/g, "");
                card = noSpacesCard.substr(noSpacesCard.length - 4, 4);
            }

            if (this.state.exp_year && this.state.exp_month) {
                expDate = `${this.state.exp_month}/${this.state.exp_year}`;
            }
        }

        return (
            <div>
                <div>
                    <OwLabel title={"card"} postText={":"} className={"me-2"} />
                    {card}
                </div>
                <div>
                    <OwLabel title={"exp_date"} postText={":"} className={"me-2"} />
                    {expDate}
                </div>
            </div>
        );
    };

    deleteExistingCard = () => {
        if (this.state.existing_card) {
            const payload: IDeleteACardDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.props.orderModel.Vendor!.guid,
                card_id: this.state.existing_card.id,
            };

            this.props.socket.emit(EndpointsEnum.PaymentsDeleteACard, payload);

            this.setState({
                isProcessing: true,
            });
        }
    };

    onDeleteExistingCard = (data: IOnDeleteACardDTO) => {
        this.setState({
            isProcessing: false,
        });
    };

    getExistingCards = () => {
        if (this.state.cardSelected) {
            return null;
        }

        return (
            <div>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <OwLabel title={"existing_cards"} />
                        <OwSelectOption
                            titleProp={""}
                            titleRenderFn={this.renderExistingCardOption}
                            valueProp={"id"}
                            options={this.state.existingCards}
                            name={"existing_card"}
                            fn={this.selectExistingCard}
                            isActive={this.state.getExistingCardsActive}
                            isDisabledOnActive={true}
                            autoSelectSingleOption={false}
                            selectedOption={this.state.existing_card}
                            selectedOptionProp={"id"}
                        />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-12 d-flex justify-content-between"}>
                        {this.state.useExistingCard ? (
                            <OwLabel title={"dont_use_existing_card"} noBottomMargin={true} fn={this.useExistingCard} />
                        ) : this.state.existingCards.length ? (
                            <OwLabel title={"use_existing_card"} noBottomMargin={true} fn={this.useExistingCard} />
                        ) : null}
                        {this.state.existing_card ? (
                            <OwLabel title={"delete_existing_card"} noBottomMargin={true} fn={this.deleteExistingCard} />
                        ) : null}
                    </div>
                </div>
            </div>
        );
    };

    isNewCardValid = () => {
        let isValid = true;

        if (this.state.card) {
            if (this.state.card.length < 13) {
                isValid = false;
            }
        } else {
            isValid = false;
        }

        if (this.state.exp_month) {
            if (this.state.exp_month.length < 2) {
                isValid = false;
            }
        } else {
            isValid = false;
        }

        if (this.state.exp_year) {
            if (this.state.exp_year.length < 4) {
                isValid = false;
            }
        } else {
            isValid = false;
        }

        if (this.state.cvc) {
            if (this.state.cvc.length < 3) {
                isValid = false;
            }
        } else {
            isValid = false;
        }

        if (!this.state.name) {
            isValid = false;
        }

        if (!this.state.billing_postal_code) {
            isValid = false;
        }

        return isValid;
    };

    useExistingCard = () => {
        const useExistingCard = !this.state.useExistingCard;

        let isChargeDisabled = this.state.isChargeDisabled;

        if (!useExistingCard) {
            if (this.isNewCardValid()) {
                isChargeDisabled = false;
            } else {
                isChargeDisabled = true;
            }
        } else {
            if (this.state.existing_card) {
                isChargeDisabled = false;
            } else {
                isChargeDisabled = true;
            }
        }

        this.setState({
            useExistingCard: !this.state.useExistingCard,
            isChargeDisabled,
        });
    };

    review = () => {
        this.setState({
            cardSelected: !this.state.cardSelected,
        });
    };

    getTotalsTable = () => {
        let tableClass = "table-dark";

        if (UIService.isMainViewLight()) {
            tableClass = "";
        }

        return (
            <table className={"table " + tableClass}>
                <tbody>
                    {this.getSubTotal()}
                    {this.getDiscountTotal()}
                    {this.getTax()}
                    {this.getLabor()}
                    {this.getShipping()}
                    {this.getCreditCardFee()}
                    {this.getGrandTotal()}
                </tbody>
            </table>
        );
    };

    getCardToUseDetail = () => {
        if (!this.props.orderModel.qbo_CardToUseDetail) {
            return null;
        } else {
            return (
                <div className={"mb-3"}>
                    <div>
                        <OwLabel title={"card_selected_to_use"} postText={":"} isBold={true} />
                    </div>
                    <div>{this.props.orderModel.qbo_CardToUseDetail.number}</div>
                    <div>
                        <OwLabel title={"exp"} className={"me-2"} postText={":"} />
                        {this.props.orderModel.qbo_CardToUseDetail.expMonth}/{this.props.orderModel.qbo_CardToUseDetail.expYear}
                    </div>
                </div>
            );
        }
    };

    getContinueButtons = () => {
        return (
            <div className={"row mt-3"}>
                <div className={"col-12"}>
                    {!this.state.cardSelected ? (
                        <OwButton
                            title={"continue"}
                            fn={this.review}
                            disabled={this.state.isChargeDisabled}
                            disableOnActive={true}
                            active={this.state.isProcessing}
                        />
                    ) : (
                        <div>
                            <OwButton
                                title={"edit"}
                                fn={this.review}
                                disabled={this.state.isChargeDisabled}
                                disableOnActive={true}
                                className={"btn-danger me-2"}
                            />
                            <OwButton
                                title={"continue"}
                                fn={this.continue}
                                disabled={this.state.isChargeDisabled}
                                disableOnActive={true}
                                active={this.state.isProcessing}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    };

    getProcessingDetail = () => {
        return this.state.doneProcessing ? (
            <div>
                <div className={"mb-3"}>
                    {this.state.updatedCardToUse ? (
                        <OwLabel title={"successfully_updated_card_to_use"} />
                    ) : (
                        <OwLabel title={"successfully_processed_payment"} />
                    )}
                </div>
                <OwButton
                    title={"return_to_order"}
                    fn={() => {
                        this.props.confirmFn(true);
                    }}
                />
            </div>
        ) : (
            <ActivityIndicator active={this.state.isProcessing} />
        );
    };

    getSetupPaymentDetail = () => {
        return (
            <div>
                {this.getTotalsTable()}

                {this.getCardToUseDetail()}

                {this.getExistingCards()}

                {this.getCardEntry()}

                {this.getCardSelectedView()}

                {this.getContinueButtons()}
            </div>
        );
    };

    render() {
        return (
            <div className={"OrderPayment"}>
                {this.state.isProcessing ? null : (
                    <div className={"text-end"}>
                        <OwButton
                            className={"btn-danger"}
                            centerIconClass={"fas fa-times"}
                            fn={() => {
                                this.props.cancelFn(true);
                            }}
                        />
                    </div>
                )}
                <div className="row">
                    <OwTitle className={"col-12"} title={"payment"} leftIconName={""} />
                </div>

                {this.props.nextStep?.onlyCollectCcToUse ? (
                    <div>
                        <OwLabel title={"select_card"} />
                    </div>
                ) : null}

                {this.state.isProcessing ? this.getProcessingDetail() : this.getSetupPaymentDetail()}
            </div>
        );
    }
}
